import { forwardRef, type HTMLAttributes, type ReactNode } from 'react';
import { cx } from '../utils/cx.js';
import styles from './ScrollArea.module.css';

export type ScrollAreaProps = HTMLAttributes<HTMLDivElement> & {
  maxHeight?: string | number;
  children: ReactNode;
};

export const ScrollArea = forwardRef<HTMLDivElement, ScrollAreaProps>(function ScrollArea(
  { maxHeight = 'min(60vh, 480px)', className, style, children, ...rest },
  ref,
) {
  const mh = typeof maxHeight === 'number' ? `${maxHeight}px` : maxHeight;
  return (
    <div ref={ref} className={cx(styles.wrap, className)} style={{ maxHeight: mh, ...style }} {...rest}>
      {children}
    </div>
  );
});
